export const GET_INSTALLED_SERVICES = 'getInstalledServices';
export const SERVICE_LEVEL_AUTO_INSTALL = 'serviceLevelAutoInstall';
export const INSTALL_SERVICES_MANUALLY = 'installServiceManually';
export const TOGGLE_MONITORING = 'toggleMonitoring';
export const GET_SERVICE_DETAIL = 'getServiceDetail';
export const UPDATE_SERVICE_DETAIL = 'updateServiceDetails';
export const AUTO_INSTALL_ALL = 'autoInstallAll';

export const SET_INSTALLED_SERVICES = 'setInstalledServices';
export const SET_SERVICE_LEVEL_AUTO_INSTALL = 'setServiceLevelAutoInstall';
export const SET_TOGGLE_MONITORING = 'setToggleMonitoring';
export const UPDATE_SERVICES_AFTER_INSTALL = 'updateServicesAfterInstall';
export const UPDATE_SERVICE_INFO = 'updateServiceInfo';
export const FILTER_SERVICES_ON_INSTALLATION_TYPE_CHANGE =
  'filterServicesOnInstallationTypeChnage';
